import { useEffect } from "react";
import { Tooltip } from "antd";

import {
  errorNotification,
  successNotification,
} from "../../ui-components/Notification";
import { UpdatecampaignAccessButton } from "../../campaign/campaign-access-management/components/UpdatecampaignAccessButton";
import { SecondaryButton } from "./ui_share";

import { getCampaignAccessData } from "../../campaign/campaign-access-management/store";
import { State } from "../../utils/store";
import { getUserList } from "../../user-management/store";

import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { getCampaignsAccessUsersData } from "../../helpers/campaignAccess";

const noDraftCampaignSavedYetTooltipMessage =
  "You need to save the draft to edit the access of users";
export const EditDraftCampaignAccess = () => {
  const dispatch = useAppDispatch();
  const { selectedClient } = useAppSelector((state: State) => state.clients);
  const { campaignAccessData } = useAppSelector(
    (state: State) => state.campaignAccessManagement
  );
  const { error: updateUsersAccessError, success: updateUsersAccessSuccess } =
    useAppSelector(
      (state: State) => state.campaignAccessManagement.updateUsersAccess
    );

  const { userList } = useAppSelector((state: State) => state.userManagement);
  const draftCampaign = useAppSelector(
    (state: State) => state.newCampaign.draftCampaign
  );

  useEffect(() => {
    if (updateUsersAccessError) errorNotification(updateUsersAccessError);
  }, [updateUsersAccessError]);

  useEffect(() => {
    if (updateUsersAccessSuccess)
      successNotification("Access modified successfully");
  }, [updateUsersAccessSuccess]);

  useEffect(() => {
    if (!selectedClient || !draftCampaign) return;
    dispatch(getUserList(selectedClient.uuid));
    dispatch(
      getCampaignAccessData({
        clientUUID: selectedClient.uuid,
        campaignUUID: draftCampaign.uuid,
      })
    );
  }, [dispatch, selectedClient, draftCampaign]);

  if (!draftCampaign?.uuid) {
    return (
      <Tooltip title={noDraftCampaignSavedYetTooltipMessage} placement="top">
        <span style={{ cursor: "not-allowed" }}>
          <SecondaryButton disabled={true} style={{ pointerEvents: "none" }}>
            Edit campaign access
          </SecondaryButton>
        </span>
      </Tooltip>
    );
  }

  const usersEnabledInCampaign = campaignAccessData[draftCampaign.uuid];
  const campaignCreatorUUID = draftCampaign.creator?.uuid || "";
  const users = getCampaignsAccessUsersData(
    campaignCreatorUUID,
    userList,
    usersEnabledInCampaign
  );

  return (
    <UpdatecampaignAccessButton
      campaignName={draftCampaign.name}
      campaignUUID={draftCampaign.uuid}
      users={users}
      buttonComponent={SecondaryButton}
    />
  );
};
